import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/Guest-blank.webp";
import ThumbImg from "../../assets/images/conversations/blank.png";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: pa-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .pa-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .pa-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 - HERO
  ══════════════════════════════════════ */
  .pa-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .pa-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .pa-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .pa-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pa-hero__title.pa-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .pa-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .pa-hero__spotify.pa-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .pa-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .pa-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .pa-hero__right.pa-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .pa-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .pa-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .pa-yt-thumb:hover img { opacity: 0.85; }
  .pa-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .pa-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .pa-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .pa-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 - BODY
  ══════════════════════════════════════ */
  .pa-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pa-body.pa-visible { opacity: 1; transform: translateY(0); }
  .pa-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .pa-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 - OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .pa-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pa-guest.pa-visible { opacity: 1; transform: translateY(0); }
  .pa-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .pa-guest__photo-bg {
    display: inline-block;
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .pa-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .pa-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .pa-inner { padding-left: 32px; padding-right: 32px; }
    .pa-hero { padding-top: 32px; padding-bottom: 48px; }
    .pa-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .pa-hero__title { font-size: 24px; }
    .pa-hero__left { gap: 16px; }
    .pa-guest__title { font-size: 24px; margin-bottom: 24px; }
    .pa-guest__photo-bg { width: 260px; height: 300px; }
    .pa-guest__name { font-size: 24px; margin-top: 18px; }
    .pa-body__para { font-size: 14px; margin-bottom: 12px; }
    .pa-body { padding-bottom: 48px; }
    .pa-guest { padding-bottom: 48px; }
    .pa-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .pa-inner { padding-left: 16px; padding-right: 16px; }
    .pa-hero { padding-top: 51px; padding-bottom: 30px; }
    .pa-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .pa-hero__left { gap: 30px; }
    .pa-hero__title { font-size: 30px; }
    .pa-body__para { font-size: 16px; margin-bottom: 10px; }
    .pa-guest__title { font-size: 30px; margin-bottom: 20px; text-align:left;}
    .pa-guest__photo-bg { width: 100%; height: 386px; }
    .pa-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .pa-body { padding-bottom: 30px; }
    .pa-guest { padding-bottom: 30px; }
    .pa-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("pa-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "YOUTUBE_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="pa-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 64 Puneet Anand"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="pa-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 64 Puneet Anand thumbnail" />
      <div className="pa-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="pa-hero">
      <div className="pa-inner">
        <div className="pa-hero__grid">
          <div className="pa-hero__left">
            <h1 ref={titleRef} className="pa-hero__title">
              EP 64 | Under the Hood: Hyundai's Clean Mobility Journey with Puneet ANAND
            </h1>
            <div ref={spotifyRef} className="pa-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/3XK3p0E9k7geruJil22PTk?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 64 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="pa-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="pa-body">
      <div className="pa-inner">
        <p className="pa-body__para">
          Three decades, countless innovations, one mission...redefine how India moves. Puneet ANAND pulls back the curtain on Hyundai's journey in clean energy, EVs, and community-driven mobility. Buckle up, it's a ride into the future.
        </p>
        <p className="pa-body__para">
          Welcome to the Energizing India Podcast. On this program, we engage with the key protagonists shaping the future of energy, mobility, and sustainability, both in India and globally. I'm your host, Ravin MIRCHANDANI, and today we're in the driver's seat with one of India's most exciting automotive journeys. The transformation of mobility as we knew it in this country. Joining us is a man who quite literally has his fingerprints across the evolution of the Indian automobile industry. Puneet Anand is the vertical head of corporate affairs, corporate communications, and social responsibilities as AVP with Hyundai Motors, India, and has an enviable 3 decades of experience in the Indian automotive sector. Since 1998, Puneet has been an integral part of Hyundai's leadership in India, steering pivotal functions and driving growth in a dynamic and often unpredictable automotive sector environment. Today, we look under the hood of Hyundai's clean energy transition from investments in EVs, hydrogen technology, and renewable energy to localization strategies that boost the resilience of India's economy. We explore the role of public policy, infrastructure, and community engagement that Hyundai plays in redefining mobility in the next generation. What does the road ahead look like for India's clean mobility revolution? How does a giant like Hyundai balance cutting-edge innovation with deep local relevance? Puneet ANAND, welcome to the program.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="pa-guest">
      <div className="pa-inner">
        <h2 className="pa-guest__title">Our Guest</h2>
        <div>
          <div className="pa-guest__photo-bg">
            <img src={GuestImg} alt="Puneet Anand" />
          </div>
          <p className="pa-guest__name">Puneet ANAND</p>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep64PuneetAnand() {
  return (
    <>
      <style>{CSS}</style>
      <div className="pa-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}